module.exports = __webpack_public_path__ + "static/media/icon-flag--unflagged.9513655e.svg";